<template>
  <!-- Grid Three  -->
  <section class="home_three_grid_sec big_container">
    <h2 class="sec_heading" v-html="shopifyData.secHeading" />
    <div class="grid_three">
      <div v-for="(value, key) in shopifyData.box" :key="key" class="grid_item">
        <a :href="value.link" class="grid_img-wrap line-h-0 d-block">
          <img
            v-lazy="value.imgUrl.src"
            class="grid_img"
            :src-placeholder="value.imgUrl.placeholder"
            :alt="value.imgUrl.alt || 'Grid Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Grid Image"
            width=""
            height=""
          />
        </a>
        <div class="grid_info">
          <h3 class="card_heading grid_heading" v-html="value.title" />
          <a :href="value.link" class="link body_text" v-html="value.linkText" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Three Grid */
.grid_three {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 25px 5px;
  padding: 45px 0 30px;
}
.sec_heading {
  grid-column: 1 / span 3;
  font-size: 18px;
  color: #000000;
  line-height: 23px;
  font-family: 'Helvetica', sans-serif;
}
@media only screen and (max-width: 991px) {
  .grid_three {
    padding: 20px 0px 25px;
  }
}
@media only screen and (max-width: 767px) {
  .grid_three {
    grid-template-columns: 1fr 1fr;
  }
  .grid_three .grid_item:first-child {
    grid-column: 2 span;
  }
  .home_three_grid_sec .sec_heading {
    padding: 0 15px;
  }
  .home_three_grid_sec.big_container {
    padding: 0;
  }
}
</style>
